import { Toast } from '@freighthub/silhouette-core'
import { observer, useComputed } from 'mobx-react-lite'
import { FC } from 'react'
import { useUIStore } from 'service/useUIStore'

export const Snack: FC = observer(() => {
  const { snack } = useUIStore()

  const snackItem = useComputed(() => {
    const { current } = snack
    if (current && current.message) {
      return current
    }
    return null
  }, [snack.current])

  if (!snackItem || !snackItem.message) {
    return null
  }

  // @ts-expect-error TS(2322) FIXME: Type 'TSnackType | undefined' is not assignable to... Remove this comment to see the full error message
  return <Toast message={snackItem.message} open={!!snack.current} onClose={snack.hideSnack} variant={snackItem.type} />
})
